import { KeyConstant } from "const";
import RemoteApi from "./RemoteApi";
import createTriosApi, { ITriosApi } from "./createTriosApi";

export class RemoteApiFactory {
  instances: { [prefixKey: string]: RemoteApi };
  triosApi: { [prefixKey: string]: ITriosApi };
  conferenceApi: object;

  constructor() {
    /**
     * Ex: {
     *  <accountId_GLOBAL_ID>: <API config for global server> - global branch
     *  <accountId_branchId>: <API config for branch server>
     */
    this.instances = {};
    this.triosApi = {};
    this.conferenceApi = {};
  }

  getInstance = (prefixKey: string, domain?: string): RemoteApi => {
    if (!prefixKey || prefixKey.includes("undefined"))
      throw new Error(`CAN NOT INIT API - Invalid prefixKey - ${prefixKey}`);

    const storageData = window.electronUtils.storage.getCommonKey(prefixKey) || {};
    const branchInfo = storageData[KeyConstant.KEY_BRANCH_INFO] || {};
    const branchDomain = domain || branchInfo.domain || branchInfo.branch_domain;

    if (!this.instances[prefixKey]) {
      this.instances[prefixKey] = new RemoteApi(prefixKey, branchDomain, storageData[KeyConstant.KEY_TOKEN]);
    }

    return this.instances[prefixKey];
  };

  getBranchApi = (prefixKey: string, domain?: string): ITriosApi => {
    if (!prefixKey || prefixKey.includes("undefined"))
      throw new Error(`CAN NOT INIT API - Invalid prefixKey - ${prefixKey}`);

    if (!this.triosApi[prefixKey]) {
      this.triosApi[prefixKey] = createTriosApi(this.getInstance(prefixKey, domain).api);
    }

    return this.triosApi[prefixKey];
  };
}

export const remoteApiFactory = new RemoteApiFactory();

export const getInstanceApi = (prefixKey: string, domain?: string) => remoteApiFactory.getInstance(prefixKey, domain);

export const getTriosApi = (prefixKey: string, domain?: string) => remoteApiFactory.getBranchApi(prefixKey, domain);

export type { ITriosApi };
